import { render, staticRenderFns } from "./GooglePayButton.vue?vue&type=template&id=07ffd6ea&scoped=true&lang=pug&"
import script from "./GooglePayButton.vue?vue&type=script&lang=js&"
export * from "./GooglePayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ffd6ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
